<template>
  <div class="form-block">
    <div class="row">
      <div class="col-12">
        <h2>Wprowadź dane adresowe osoby wypełniającej formularz</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <label>
          <input
            type="checkbox"
            v-model="isPoland"
            @click="changeCountryName(true)"
          />
          Polska
        </label>
      </div>
      <div class="col-12" v-if="!isPoland">
        <label><input
          class="text-input"
          type="text"
          style="margin-bottom: 0; width: 30rem; margin-right: 1rem"
          v-model="countryName"
        />
          Nazwa kraju
        </label>
      </div>
      <div class="col-8" v-if="!isPoland"></div>
      <PolishAddress ref="polishAddress" v-if="isPoland"/>
      <ForeignAddress ref="foreignAddress" v-else/>
    </div>
  </div>
</template>

<script>
import PolishAddress from "@/components/declarations/PolishAddress";
import ForeignAddress from "@/components/declarations/ForeignAddress";
import Common from "@/components/declarations/validators/Common";

export default {
  name: "CustomAddressScreen",
  components: {ForeignAddress, PolishAddress},
  mixins: [Common],
  data() {
    return {
      isPoland: true,
      countryName: ''
    }
  },
  methods: {
    setData(data) {
      if (!data.is_address_different_D05) {
        return;
      }
      this.isPoland = data.is_address_different_D05 && data.polish_personal_address.formatted_address;
      this.$nextTick(() => {
        if (this.isPoland) {
          this.$refs.polishAddress.setData(data.polish_personal_address);
        } else {
          this.countryName = data.foreign_personal_address.country_D06;
          this.$refs.foreignAddress.setData(data.foreign_personal_address);
        }
      });
    },
    emitChange() {
      const data = {
        polishAddress: this.isPoland ? this.$refs.polishAddress.getAddress() : null,
        foreignAddress: !this.isPoland ? {
          ...this.$refs.foreignAddress.getAddress(),
          country_D06: this.countryName
        } : null,
      }
      this.$emit('update', data);
    },
    changeCountryName(clearCustomName) {
      if (clearCustomName) {
        this.countryName = "";
      }
      if (!this.countryName) {
        this.isPoland = true;
        return;
      }
      this.isPoland = false;
    },
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

input[type=text] {
  height: 2rem;
  font-size: .8rem;
}
</style>
